/**
 * Article
 * 
 * helps with formatting the richtext content
 *  - adds a class to image wrappers to override default styles
 */

import { gsap } from 'gsap'
import { debug } from '../modules/util'

const name = 'Article'
const images = document.querySelectorAll('.article__content img')

init()

function init () {
  debug(`${name}.init()`, images)

  initImages()
}

function initImages () {
  if (!images.length) {
    return false
  }

  gsap.utils.toArray(images).forEach((img) => {
    if (!img.parentElement.classList.contains('article__content')) {
      img.parentNode.className = 'rte__image-wrapper'
    }
  })
}

export default { init }